module.exports = __webpack_public_path__ + "staticesp/media/marcas (4).bab428df.jpg";